export const SLIDER_SETTINGS = {
  slidesToShow: 2,
  slidesToScroll: 2,
  dots: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
